export default "__VITE_ASSET__FAMfxzvy__"